import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { getAccessToken, saveAccessTokens } from '@ecp/common/src/utils/utils';

import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import UserInfoProvider from '@fo-components/common/provider/UserInfoProvider';
import SsoRoutes from '@ecp/fo/src/routes/SsoRoutes';
import GuestRoutes from '@ecp/fo/src/routes/GuestRoutes';
import authApi from '@fo-apis/common/authApi';

const ProtectedRoutes = () => {
  const [checkingToken, setCheckingToken] = useState(!getAccessToken());

  const {
    systemInformation: { isPossibleKnoxLogin },
    isNoMemberUseYn,
  } = useSiteInfo();

  const { pathname } = useLocation();

  useEffect(() => {
    let mounted = true;

    const restoreAccessToken = async () => {
      if (getAccessToken()) {
        setCheckingToken(false);
        return;
      }

      try {
        const {
          data: {
            result: { accessToken },
          },
        } = await authApi.reissue();

        if (accessToken) {
          saveAccessTokens(accessToken);
        }
      } catch (e) {
        // refresh token cookie가 없거나 만료된 경우 기존 미로그인 라우팅으로 진행한다.
      } finally {
        if (mounted) {
          setCheckingToken(false);
        }
      }
    };

    restoreAccessToken();

    return () => {
      mounted = false;
    };
  }, []);

  const notLoggedInRoutes = () => {
    switch (isPossibleKnoxLogin) {
      case '':
        return <></>;
      case true:
        return <SsoRoutes />;
      case false:
        switch(isNoMemberUseYn) {
          case true:
            return <GuestRoutes />;
          case false:
            return <Navigate to="login" replace state={{ prev: pathname, current: '/login' }} />;
            default:
              return <></>;  
        }
      default:
        return <></>;
    }
  };

  if (checkingToken) {
    return <></>;
  }

  return getAccessToken() ? (
    <UserInfoProvider>
      <Outlet />
    </UserInfoProvider>
  ) : (
    notLoggedInRoutes()
  );
};

export default ProtectedRoutes;
